import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { useLocalStorage } from "@uidotdev/usehooks";
import { Link } from "react-router-dom";

const SustainabilityInMilkGrading = () => {
  const [storedName] = useLocalStorage("name", null);
  const { brandData, loading, errors } = useTraceabilityData();

  const brandName = brandData?.logo?.brandName || "Our Brand";

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Sustainability in Milk Grading</h2>
      </div>

      {/* Intro Section */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {loading.brand && "Loading brand information..."}
                {!loading.brand && errors.brand && "Error loading brand information."}
                {!loading.brand && !errors.brand && (
                  <>
                    At <strong>{brandName}</strong>, sustainability is more than a commitment—it's a way of life. Our milk grading process integrates eco-conscious practices to reduce environmental impact while ensuring efficiency and quality. From solar-powered centers to electric transportation, every step contributes to building a greener future.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sustainability Highlights */}
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Solar-Powered-Grading-Centers_-min.png" alt="Solar-Powered Grading Centers" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Solar-Powered
                  <br />
                  Grading Centers
                </h6>
              </div>
            </div>

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Electric-Vehicle-Transportation_-min.png" alt="Electric Vehicle Transportation" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Electric Vehicle
                  <br />
                  Transportation
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/Reduced-Carbon-Footprint_-min.png" alt="Reduced Carbon Footprint" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Reduced Carbon
                  <br />
                  Footprint
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/empowering-farmers-and-communities"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/cloud-connectivity"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>

      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Milk Grading Insights */}
      {/* <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Milk Grading Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <a href="technology-driven">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-45.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      Technology-Driven
                      <br /> Quality Checks
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="empowering-farmers-and-communities">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-46.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                      Empowering Farmers & Communities
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="sustainability-in-milk-grading">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-47.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      Sustainability in Milk Grading
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="cloud-connectivity">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-48.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ top: "30%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>Cloud Connectivity</h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}

      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Traceability Journey */}
      {/* <div className="wrapper2">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div> */}

      {/* <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />

            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />

            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />

            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />

            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />

            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SustainabilityInMilkGrading;

